import React from "react";

const CBVisiblity = () => {
  return <div>CBVisiblity</div>;
};

export default CBVisiblity;
